import { Injectable } from '@angular/core'
import { signalState, patchState } from '@ngrx/signals'
import { SearchFeedbackRequestDTO, FullAttributesDTO } from '../../../apiModule'

export interface FeedbackArchiveState {
  search: SearchFeedbackRequestDTO
  scroll: number
  fullAttributes: FullAttributesDTO
  isLoading: boolean
  error: string | null
}

const initialState: FeedbackArchiveState = {
  search: { status: 'CLOSED', onlyUnreadFeedback: false, onlyUnreadMessages: false },
  scroll: 0,
  fullAttributes: { product_TYPE: [], consumer_TYPE: [], brand: [], made_IN: [] },
  isLoading: false,
  error: null
}

@Injectable({ providedIn: 'root' })
export class FeedbackArchiveStoreService {
  readonly feedbackArchiveState = signalState<FeedbackArchiveState>(initialState)

  updateSearch(search: SearchFeedbackRequestDTO): void {
    patchState(this.feedbackArchiveState, { search })
  }

  updateScroll(scroll: number): void {
    patchState(this.feedbackArchiveState, { scroll })
  }

  updateFullAttributes(fullAttributes: FullAttributesDTO): void {
    patchState(this.feedbackArchiveState, { fullAttributes })
  }

  setLoading(isLoading: boolean): void {
    patchState(this.feedbackArchiveState, { isLoading })
  }

  setError(error: string | null): void {
    patchState(this.feedbackArchiveState, { error })
  }

  reset(): void {
    patchState(this.feedbackArchiveState, initialState)
  }
}
